<style lang="scss" scoped>
.about-page {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.head-gradient {
  position: absolute;
  z-index: 15;
  top: 0;
  width: 100%;
  height: 550px;
  background-image: linear-gradient(to top, $black, rgba($black, .4), transparent, rgba($black, .6), $black);

  @include media(max, lg) {
    top: 12px;
    height: 235px;
    background: linear-gradient(180deg, rgba($black, .0001) 0%, $black 100%);
  }
}

.content {
  @include margin-x(auto);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 20;
}

.wrapper {
  width: 1020px;
  @include margin-x(auto);
  position: relative;
  z-index: 20;

  @include media(max, lg) {
    width: 600px;
  }

  @include media(max, md) {
    width: 100%;
    padding: 0 15px;
  }
}

.statistics-block {
  margin-top: 86px;

  @include media(max, lg) {
    margin: 44px 0 0;
  }
}

.shop-block {
  margin-top: 80px;

  @include media(max, lg) {
    margin-top: 50px;
  }
}

.shop-mobile-block {
  margin-top: 60px;
}

.possibilities-block {
  margin-top: 70px;

  @include media(max, lg) {
    margin-top: 50px;
  }
}

.market-block {
  margin-top: 120px;

  @include media(max, lg) {
    margin: 40px 0;
  }
}

.participate-block {
  margin-top: 130px;

  @include media(max, lg) {
    margin-top: 50px;
  }
}

.chatting-block {
  margin-top: 120px;

  @include media(max, lg) {
    margin: 0;
  }
}

.best-moments-block {
  margin-top: 45px;

  @include media(max, lg) {
    margin: 0 0 60px;
  }
}

.developers-block {
  margin-top: -80px;

  @include media(max, lg) {
    margin-top: 0;
  }

  @include media(max, lg) {
    margin-bottom: 60px;
  }
}

.last-action {
  margin-top: -57px;

  @include media(max, lg) {
    margin: 0 0 60px;
  }
}

.partners-block {
  margin-top: 0;
  margin-bottom: 40px;
}
</style>

<template>
  <main-layout class="about">
    <div class="about-page">
      <head-action/>
      <container>
        <div class="content">
          <statistics-block :freeGames="freeGamesCount" :paidGames="paidGamesCount"/>
          <possibilities-block/>
          <shop-mobile-block-cloud v-if="!appIsExtraLarge && isRu" :freeGames="freeGamesCount" :paidGames="paidGamesCount" :cloudGames="cloudGamesCount" />
          <shop-mobile-block v-if="!appIsExtraLarge && !isRu" :freeGames="freeGamesCount" :paidGames="paidGamesCount" />
        </div>
      </container>
      <shop-block-cloud v-if="appIsExtraLarge && isRu" :scroll-top="scrollTop" :freeGames="freeGamesCount" :paidGames="paidGamesCount" :cloudGames="cloudGamesCount" />
      <shop-block v-if="appIsExtraLarge && !isRu" :scroll-top="scrollTop" :freeGames="freeGamesCount" :paidGames="paidGamesCount" />
      <market-block/>
      <best-moments-block/>
      <div class="wrapper">
        <chatting-block/>
      </div>
      <developers-block/>
      <last-action :scroll-top="scrollTop"/>
    </div>
  </main-layout>
</template>

<script>

import {
  availableLanguagesFull, getAlternateUrls, getFavicons, getCanonical,
} from '@utils/helpers';
// eslint-disable-next-line camelcase
import { query_string, qsStringify, Backend } from '@vkplay/shared';
import HeadAction from '@components/AboutComponents/HeadAction.vue';
import StatisticsBlock from '@components/AboutComponents/StatisticsBlock.vue';
import PossibilitiesBlock from '@components/AboutComponents/PossibilitiesBlock.vue';
import ChattingBlock from '@components/AboutComponents/ChattingBlock.vue';
import MarketBlock from '@components/AboutComponents/MarketBlock.vue';
import BestMomentsBlock from '@components/AboutComponents/BestMomentsBlock.vue';
import DevelopersBlock from '@components/AboutComponents/DevelopersBlock.vue';
import ShopBlockCloud from '@components/AboutComponents/ShopBlockCloud.vue';
import ShopBlock from '@components/AboutComponents/ShopBlock.vue';
import LastAction from '@components/AboutComponents/LastAction.vue';
import ShopMobileBlockCloud from '@components/AboutComponents/ShopMobileBlockCloud.vue';
import ShopMobileBlock from '@components/AboutComponents/ShopMobileBlock.vue';

const apiCatalogUrl = 'https://api.vkplay.ru/play/v2/catalog/';

export default {
  name: 'About',
  components: {
    ShopMobileBlockCloud,
    ShopMobileBlock,
    LastAction,
    ShopBlockCloud,
    ShopBlock,
    DevelopersBlock,
    BestMomentsBlock,
    MarketBlock,
    ChattingBlock,
    PossibilitiesBlock,
    StatisticsBlock,
    HeadAction,
  },
  page() {
    const search = query_string(window.location.search);

    delete search.lang;

    const currentLangFull = availableLanguagesFull[this.getCurrentLang];
    const shouldAddLang = this.getCurrentLang !== 'en';
    const searchQuery = {
      ...search,
      ...shouldAddLang && { lang: currentLangFull },
    };

    let searchString = qsStringify(searchQuery);

    if (searchString.length > 0) {
      searchString = `?${searchString}`;
    }

    return {
      title: 'About',
      link: [
        {
          rel: 'canonical',
          href: getCanonical(),
        },
        ...getAlternateUrls(),
        ...getFavicons(),
      ],
      htmlAttrs: { lang: this.getCurrentLang },
      ...this.getCurrentLang === 'ru' && {
        titleTemplate: 'Игровой центр — скачать Игровой центр | VK Play',
        meta: [
          {
            name: 'description',
            content: 'Загрузить Игровой центр, приложение которое позволит вам комфортно скачивать и запускать игры. Откройте игровой мир, наполненный сражениями и приключениями',
          },
        ],
      },
      ...this.getCurrentLang !== 'ru' && {
        titleTemplate: 'VK Play',
      },
    };
  },
  data() {
    return {
      scrollTop: 0,

      freeGamesCount: null,
      paidGamesCount: null,
      cloudGamesCount: null,
      isRu: false,
    };
  },
  created() {
    this.getFreeGamesCount();
    this.getPaidGamesCount();
    this.getCloudGamesCount();
  },
  mounted() {
    window.addEventListener('scroll', this.checkScroll);
    setTimeout(() => {
      // eslint-disable-next-line no-underscore-dangle
      this.isRu = !!window.__GEMS && window.__GEMS.country_id ? window.__GEMS.country_id === '188' : this.getCurrentLang === 'ru';
    }, 800);
  },
  methods: {
    checkScroll() {
      this.scrollTop = window.pageYOffset || document.scrollTop || document.body.scrollTop;
    },
    getFreeGamesCount() {
      return Backend.get(apiCatalogUrl)
        .then((response) => {
          const { count } = response;

          this.freeGamesCount = count;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.warn('Get free games count error:', error);
        });
    },
    getPaidGamesCount() {
      return Backend.get(apiCatalogUrl, { is_sellable: 1 })
        .then((response) => {
          const { count } = response;

          this.paidGamesCount = count;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.warn('Get paid games count error:', error);
        });
    },
    getCloudGamesCount() {
      return Backend.get(apiCatalogUrl, { is_cloud: 1 })
        .then((response) => {
          const { count } = response;

          this.cloudGamesCount = count;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.warn('Get cloud games count error:', error);
        });
    },
  },
};

</script>
